import { render, staticRenderFns } from "./DataTableLoader.vue?vue&type=template&id=5c2a0ac8&scoped=true"
import script from "./DataTableLoader.vue?vue&type=script&lang=js"
export * from "./DataTableLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2a0ac8",
  null
  
)

export default component.exports